import { Checkbox, FormControlLabel, FormGroup } from '@mui/material';

interface CheckboxWithLabelInterface {
  value: boolean | undefined;
  setValue(val: boolean): void;
  label: string;
  disabled?: boolean;
}

export const CheckboxWithLabel = ({
  value,
  setValue,
  label,
  disabled,
}: CheckboxWithLabelInterface) => {
  // Ensure value is always a boolean to prevent controlled/uncontrolled component warnings
  const checkedValue = value ?? false;

  return (
    <FormGroup>
      <FormControlLabel
        label={label}
        sx={{ display: 'flex', fontWeight: 500, whiteSpace: 'nowrap' }}
        control={
          <Checkbox
            checked={checkedValue}
            size='small'
            onChange={() => setValue(!checkedValue)}
            color='primary'
            disabled={disabled}
          />
        }
      />
    </FormGroup>
  );
};
